module.exports = __webpack_public_path__ + "img/nav_logo.f79877ac.png";